import Vue from 'vue'
import Toasted from '@/plugin/vue-toasted'
// import {BrowserMultiFormatReader} from '@zxing/library'
import {BrowserMultiFormatReader} from '@/plugin/zxing'
import App from './App.vue'
import router from './router'
import SocketPlugin from '@/plugin/socket-plugin'
import '@mdi/font/css/materialdesignicons.css'
import UAParser from 'ua-parser-js'

Vue.config.productionTip = false
Vue.prototype.$client = SocketPlugin
Vue.prototype.$codeReader = new BrowserMultiFormatReader()

const parser = new UAParser()
Vue.prototype.$ua = parser.getResult()

let vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)

window.addEventListener('resize', () => {
  console.log('[RESIZE] ' + window.innerHeight)
	let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

Vue.use(Toasted, {
  duration: 5000,
  fitToScreen: false,
  fullWidth: false,
  position: 'top-center',
  iconPack: 'mdi',
  theme: 'bubble'
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
